export function WeChatOfficialAccountIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="58" height="58" viewBox="0 0 58 58" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect width="58" height="58" rx="12" fill="#01CC7A" />
      <path d="M21.2867 29.9469C21.2867 29.9469 17.2944 20.7442 23.9257 16.7519C30.557 12.7595 37.7974 19.3909 37.7974 19.3909C37.7974 19.3909 31.166 17.4285 25.888 21.3532C22.1664 24.1275 21.2867 29.9469 21.2867 29.9469Z" fill="white" />
      <path d="M31.2329 23.3158C31.2329 23.3158 39.1499 25.9548 39.8266 31.9095C40.5032 37.8641 36.5109 42.4655 36.5109 42.4655C36.5109 42.4655 44.9016 38.5408 43.8189 31.2328C42.4656 22.6391 33.1952 22.6391 31.2329 23.3158Z" fill="white" />
      <path d="M25.1435 38.0675L22.5722 39.1502L21.8955 36.1728C16.4822 33.3308 16.6175 26.6318 16.6175 26.6318C16.6175 26.6318 12.4222 35.4962 19.9332 41.1125C22.5722 43.0748 28.1885 42.6688 30.5569 41.7892C35.8349 39.8268 35.8349 35.2255 35.8349 35.2255C35.8349 35.2255 31.2335 39.1502 25.1435 38.0675Z" fill="white" />
    </svg>
  );
}

export const displayName = "WeChatOfficialAccountIcon";
